const getDistance = async (destination: string) => {
  const url = `/api/distance?destination=${destination}`

  try {
    const response = await fetch(url)
    return await response.json()
  } catch (error) {
    console.error('Error:', error)
  }
}

export { getDistance }
